/**
 * Created by asiulik on 19.05.2017.
 */

define(['jquery', 'lodash', 'eventEmitter/EventEmitter', './pageConst', './pageHistory', './changePageAnimations/changePageAnimations', './pageAssets', '../../utils'], function ($, _, EventEmitter, PageConst, PageHistory, ChangePageAnimations, PageAssets, Utils) {

    var $document = $(document), $window = $(window);

    var animationsConfig = {

        teaserExpand: {
            name: "teaserExpand",
            changePage: ChangePageAnimations.changePageTeaserExpand,
            changePageMobile: ChangePageAnimations.changePageTeaserExpand //can pass other change page fn
        },
        changePageThemenFinderBack: {
            name: "changePageThemenFinderBack",
            changePage: ChangePageAnimations.changePageThemenFinderBack,
        },
        default: {
            name: "default",
            changePage: ChangePageAnimations.changePageDefault
        }

    };

    function Page(layoutInstace, preloadInstace) {
        this.layout = layoutInstace;
        this.preloader = preloadInstace;
    }

    Page.prototype = _.clone(EventEmitter.prototype);

    Page.prototype.actionsPreventingGetPageOnBack = [];

    Page.prototype.init = function () {

        this.history = new PageHistory();
        this.pagePreventActions = new PageActionsPrevent();
        this.bindEvents();

        this.customAnimationData = {};

    };

    Page.prototype.bindEvents = function () {

        var _this = this;

        this.bindChangePageEvents();
        this.bindPopStateEvents();

        this.on('getPageStart', function (e) {
            console.log('getPageStart')
            PageAssets();
        });

        this.on('getPageDone', function (e) {
            console.log('getPageDone')
            _this.changePagePending = false;
            PageAssets().handleNewAssets(e.data);
        });

        this.on('getPageFail', function (e) {
            _this.changePagePending = false;
        });

        this.on('page:content:reload:secondnav', function (content) {

            var $navContent = $(content).find('#nav');
            var $nav = $('#nav');

            $nav.html($navContent);

        });

    };

    function htmlDecode(input){
        var e = document.createElement('div');
        e.innerHTML = input;
        return e.childNodes[0].nodeValue;
    }

    Page.prototype.setPageData = function ($data) {
        var pageTitle = $data.filter('title').get(0),
            assetsUrlNode = $data.filter('script#assetsUrl').get(0);

        if (!!pageTitle) window.document.title = htmlDecode(pageTitle.innerHTML);
        if (!!assetsUrlNode) eval.call(window, assetsUrlNode.innerHTML);
    };

    Page.prototype.getPage = function (url, $link, storeScrollPosition) {

        this.emit('startChangePage');
        this.startChangePage(url, $link);

        if(storeScrollPosition){
            this.pageScrollOffset = $window.scrollTop();
        }

    };

    Page.prototype.startChangePage = function(url, $link, animationType){

        var animationConfig = animationsConfig[animationType || this.getAnimationType($link)];

        if (animationConfig.changePageMobile) {
            if (this.layout.mobile) return animationConfig.changePageMobile.call(this, url, animationConfig, $link);
        }

        return animationConfig.changePage.call(this, url, animationConfig, $link);

    };

    Page.prototype.getAnimationType = function ($link) {
        return $link ? ($link.data('changeType') || 'default') : 'default'
    };

    Page.prototype.ajaxPage = function (url) {
        return $.ajax({
            url: url,
            type: 'GET',
            // beforeSend: function () {
            //
            // },
            // complete: function (jqXHR, textStatus) {
            //     debugger;
            // },
            // error: function (jqXHR, textStatus, errorThrown) {
            //     debugger;
            // },
        }).then(function (data, textStatus, jqXHR) {
            if (data.indexOf('http-equiv="refresh"') > -1) {

                var redirectUrl = data.replace(/^.*?url=(.*?)".*?$/, '$1');

                window.location = $('<textarea />').html(redirectUrl).text();

                return 'redirect';
            } else {
                return data;
            }

        }, function (jqXHR) {
            return jqXHR;
        });
    };

    Page.prototype.bindChangePageEvents = function () {

        var _this = this;
        $(document).on({
            click: function (e) {

                var $this = $(this);

                if ($this.attr('target') === '_blank') return;
                if (!$this.attr('href') || $this.attr('href') === '' || $this.attr('href') === '#') return;
                if (e.currentTarget.hostname !== window.location.hostname) return;

                if ($this.attr('default-link')) {
                    return;
                }

                e.preventDefault();

                _this.emit('getPageStart');

                _this.changePagePending = true;

                var url = e.currentTarget.href;


                if( navigator.geolocation && $this[0].hasAttribute('geolocation-link') ){
                    navigator.geolocation.getCurrentPosition(function(position){
                        url = Utils.addQueryStringParamsToUrl('latitude', position.coords.latitude.toFixed(3), url);
                        url = Utils.addQueryStringParamsToUrl('longitude', position.coords.longitude.toFixed(3), url);
                        _this.getPage(url, $this, true);
                        _this.history.setHistory(url);
                    }, function(e){
                        _this.getPage(url, $this, true);
                        _this.history.setHistory(url);
                    });
                }else{
                    _this.getPage(url, $this, true);
                    _this.history.setHistory(url);
                }

                window.tracking.trackGTM({
                    'event': 'VirtualPageview',
                    'virtualPageURL': location.pathname
                });

                window.tracking.trackGA([
                    'send',
                    'pageview',
                    location.pathname
                ]);
            }

        }, this.buildAsyncLinksSelector());

    };

    Page.prototype.updateHistory = function (url) {
        history.replaceState({}, '', url);
    };

    Page.prototype.forceUpdateContentElements = function(elementsConfig, content){

        var initConfig = [];

        var $content = $(content);

        //@todo add some content filter mechanics to do user name replacing in a proper way

        var re = new RegExp("userName=([^;]+)");
        var cookieUserName = re.exec(document.cookie);
        cookieUserName = (cookieUserName != null) ? decodeURIComponent(cookieUserName[1]).replace('+', ' ') : null;

        if (cookieUserName) {
            userName = cookieUserName
        } else {
            userName = $.trim($('.logged-username').eq(0).text());
        }

        var $content = $(content);

        if (userName) {
            $content.find('.logged-username').text(userName);
        }

        elementsConfig = initConfig.concat( elementsConfig );

        content = $('<div></div>').append($content).html();

        if(elementsConfig.indexOf('secondnav') > -1 ){
            this.emit('page:content:reload:secondnav', content);
        }

        return content;

    };

    Page.prototype.bindPopStateEvents = function () {

        var _this = this;

        $window.on('popstate', function (e) {

            if (_this.pagePreventActions.actionsPreventingGetPageOnBack.length) {

                e.preventDefault();
                _this.pagePreventActions.resolvePreventingActions();
                return false;
            }

            _this.changePageType = 'popstate';

            _this.emit('getPageStart');

            _this.getPage(window.location.href);

        });

    };

    Page.prototype.resetScrollPosition = function(duration){

        if(this.changePageType == 'popstate') {

            Utils.scrollPositionAnimate(this.pageScrollOffset, duration || 300);
            this.changePageType = undefined;
            return;
        }

        if($window.scrollTop() > 400)
            $window.scrollTop(400);

        Utils.scrollPositionAnimate(0, duration || 300);

    };

    Page.prototype.clearCustomAnimationData = function () {
        this.customAnimationData = {};
    };

    Page.prototype.buildAsyncLinksSelector = function () {
        return 'body:not(' + PageConst.neosBodyClass + ') a';
    };

    Page.prototype.addPreventAction = function (actionInstance) {
        this.pagePreventActions.addPreventAction(actionInstance);
    };

    Page.prototype.removePreventActions = function (action) {

        this.pagePreventActions.removePreventActions(action);
    };

    Page.prototype.removePreventActionsAll = function () {
        this.pagePreventActions.actionsPreventingGetPageOnBack = [];
    };

    function PageActionsPrevent() {
        this.actionsPreventingGetPageOnBack = [];
    }

    PageActionsPrevent.prototype.addPreventAction = function (actionInstance) {
        if (!actionInstance.preventResolve) throw new Error('PAGE: actionInstance should implement preventResolve method.');
        this.actionsPreventingGetPageOnBack.push(actionInstance);
    };

    PageActionsPrevent.prototype.removePreventActions = function (action) {

        var index = this.actionsPreventingGetPageOnBack.indexOf(action);
        if (index > -1) {
            this.actionsPreventingGetPageOnBack.splice(index, 1);
        }

    };

    PageActionsPrevent.prototype.resolvePreventingActions = function () {

        [].forEach.call(this.actionsPreventingGetPageOnBack, function (actionInstance) {
            actionInstance.preventResolve();
        });

        this.actionsPreventingGetPageOnBack = [];
    };

    return Page;

});


// WEBPACK FOOTER //
// ./Private/Scripts/core/page/page.js